import { Button, Checkbox, Flex, Text, Tooltip, useToast } from '@chakra-ui/react';
import { HistoricoPedido } from './HistoricoPedido';
import * as T from '../../components/Table';
import { useMutation, useQueryClient } from 'react-query';
import { api } from '../../services/api';
import { UpdateEntrega } from './UpdateEntrega';
import { CancelarPedido } from './CancelarPedido';

async function updateStatusEntrega({ numeroNota }) {
  await api.post('/site/v2/crm-controle/atualiza-status-entrega', {
    numero_nota: numeroNota
  });
}

async function cancelRastreioJ3({ numeroPedido }) {
  const response = await api.get(`/site/v2/tracken/cancelar-pedido-tracken/${numeroPedido}`);

  return response.data;
}

export function Pedido({ item, isOdd }) {
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true
  });

  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: () => updateStatusEntrega({ numeroNota: item.numero_nota }),
    onSuccess: () => {
      toast({
        title: 'Status de entrega atualizado com sucesso',
        status: 'success'
      });

      queryClient.invalidateQueries('getPedidos');
    },
    onError: (error) => {
      toast({
        title: 'Erro ao atualizar status de entrega',
        description: 'Tente novamente',
        status: 'error'
      });
    }
  });

  const { mutateAsync: handleCancelRastreioJ3, isLoading: loadingCancelRastreioJ3 } = useMutation({
    mutationFn: () => cancelRastreioJ3({ numeroPedido: item.numero_pedido }),
    onSuccess: () => {
      toast({
        title: 'Pedido cancelado com sucesso',
        status: 'success'
      });

      queryClient.invalidateQueries('getPedidos');
    },
    onError: (error) => {
      toast({
        title: 'Erro ao cancelar pedido',
        description: 'Tente novamente',
        status: 'error'
      });
    }
  });

  return (
    <T.Tr key={item.codigo_remessa}>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        <Flex flexDir="column" mx="auto">
          <Text>{item.numero_pedido}</Text>
          <Text>{item.data_aprovacao}</Text>
        </Flex>
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        {item.numero_nfe}
      </T.Td>

      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        <Tooltip textTransform="capitalize" label={item.cliente} aria-label="A tooltip">
          <Text textTransform="capitalize" isTruncated maxW="150px" mx="auto">
            {item.cliente}
          </Text>
        </Tooltip>
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        {item.status_atual}
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        <HistoricoPedido statusAtual={item.status_atual} historico={item.historico} />
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        <Tooltip textTransform="capitalize" label={item.destinatario} aria-label="A tooltip">
          <Text textTransform="capitalize" isTruncated maxW="130px">
            {item.destinatario}
          </Text>
        </Tooltip>
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        <Text textTransform="capitalize">{item.codigo_remessa}</Text>
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        <Text textTransform="capitalize">{item.valor_nota}</Text>
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        <Text textTransform="lowercase">{item.prazo_entrega}</Text>
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        <Text textTransform="lowercase">{item.previsao_saida}</Text>
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        <Text textTransform="capitalize">{item.data_coleta}</Text>
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        {item.ultima_atualizacao}
      </T.Td>
      <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
        {item.status_entregue.data_entregue ? (
          <Flex flexDir="column" mx="auto" alignItems="center">
            <Text>{item.status_entregue.nome_usuario}</Text>
            <Text>{item.status_entregue.data_entregue}</Text>
          </Flex>
        ) : (
          <UpdateEntrega onClick={() => mutateAsync()} isLoading={isLoading} />
        )}
      </T.Td>
      {!item.status_entregue.data_entregue ? (
        <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}>
          <CancelarPedido
            onClick={() => handleCancelRastreioJ3({ numeroPedido: item.numero_pedido })}
            isLoading={loadingCancelRastreioJ3}
          />
        </T.Td>
      ) : (
        <T.Td borderRight="1px solid #cfcfcf" bg={isOdd ? 'gray.50' : 'white'}></T.Td>
      )}
      <T.Td bg={isOdd ? 'gray.50' : 'white'}>
        <Flex alignItems="center" justifyContent="space-between" gap={1}>
          {item.link_etiqueta_endereco && (
            <Button
              as="a"
              href={item.link_etiqueta_endereco}
              target="_blank"
              size="xs"
              fontSize="9px"
              colorScheme="blue">
              Etqt. Endereço
            </Button>
          )}

          {item.link_etiqueta_comum && (
            <Button
              as="a"
              href={item.link_etiqueta_comum}
              target="_blank"
              size="xs"
              fontSize="9px"
              colorScheme="blue">
              Etiqueta
            </Button>
          )}

          {item.link_nota_fiscal && (
            <Button
              as="a"
              href={item.link_nota_fiscal}
              target="_blank"
              size="xs"
              fontSize="9px"
              colorScheme="blue">
              Nota
            </Button>
          )}

          {item.link_xml && (
            <Button
              as="a"
              href={item.link_xml}
              target="_blank"
              size="xs"
              fontSize="9px"
              colorScheme="blue">
              XML
            </Button>
          )}
          {item.link_nota_remessa && (
            <Button
              as="a"
              href={item.link_nota_remessa}
              target="_blank"
              size="xs"
              fontSize="9px"
              colorScheme="blue">
              Remessa
            </Button>
          )}
          {item.link_xml_remessa && (
            <Button
              as="a"
              href={item.link_xml_remessa}
              target="_blank"
              size="xs"
              fontSize="9px"
              colorScheme="blue">
              XML Remessa
            </Button>
          )}
        </Flex>
      </T.Td>
    </T.Tr>
  );
}
